import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import formattingText from "@/components/view/formattingText.vue";

import STATUS  from "@/components/model/enum"
import fallBackimage from '../../assets/images/fallBackImage.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'patientView',
  props: {
    patientInfo:{
        type:Object,
        default:function(){
            return {}
        }
    }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_image, {
              width: 200,
              height: 200,
              preview: false,
              src: __props.patientInfo.docs && __props.patientInfo.docs.length > 0 &&  __props.patientInfo.docs.filter(e=>e.type==='AVATAR').length>0? __props.patientInfo.docs.filter(e=>e.type==='AVATAR')[0].path :'',
              fallback: _unref(fallBackimage)
            }, null, 8, ["src", "fallback"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(formattingText, {
              leftText: "姓名",
              rightText: __props.patientInfo.name
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "生日",
              rightText: __props.patientInfo.born
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "性别",
              rightText: __props.patientInfo.gender ? _unref(STATUS)('genderType').getDesc(__props.patientInfo.gender) : ''
            }, null, 8, ["rightText"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(formattingText, {
              leftText: "邮箱",
              rightText: __props.patientInfo.email
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "手机号",
              rightText: __props.patientInfo.mobile
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "身份证",
              rightText: __props.patientInfo.idNumber
            }, null, 8, ["rightText"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})